/**
 * Shared UI component for UI Stat Card.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { Component, input } from '@angular/core';

import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

@Component({
  selector: 'ui-stat-card',
  standalone: true,
  imports: [UiLabelTranslatePipe],
  templateUrl: './ui-stat-card.component.html',
  styleUrl: './ui-stat-card.component.scss'
})
export class UiStatCardComponent {
  readonly label = input('');
  readonly value = input('');
  readonly delta = input('');
}
